"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricFormatterPipe = void 0;
const core_1 = require("@angular/core");
const data_metric_service_1 = require("./data-metric.service");
let MetricFormatterPipe = class MetricFormatterPipe {
    constructor(_dataMetric) {
        this._dataMetric = _dataMetric;
    }
    transform(value, metricConfig) {
        if (typeof value === 'undefined') {
            // no value provided
            console.warn('No value to format', value);
            return '';
        }
        return this._dataMetric.formatMetricValue(value, metricConfig);
    }
};
exports.MetricFormatterPipe = MetricFormatterPipe;
exports.MetricFormatterPipe = MetricFormatterPipe = __decorate([
    (0, core_1.Pipe)({
        name: 'metricFormatter'
    }),
    __metadata("design:paramtypes", [data_metric_service_1.DataMetricService])
], MetricFormatterPipe);
//# sourceMappingURL=metric-formatter.pipe.js.map